import React from 'react';
import { Box, Container, Divider, Link as MuiLink, Typography } from '@mui/material';
import SEO from '../components/SEO';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
    <SEO title={t('privacyPolicy.seoTitle')} description={t('privacyPolicy.seoDescription')} path="/privacy" />
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 7 } }}>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
        {t('privacyPolicy.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('privacyPolicy.lastUpdated', { date: t('privacyPolicy.lastUpdatedDate') })}
      </Typography>

      <Box sx={{ display: 'grid', gap: 3 }}>
        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.scope.title')}
          </Typography>
          <Typography variant="body1">
            {t('privacyPolicy.sections.scope.body')}
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.dataCollected.title')}
          </Typography>
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            <li>{t('privacyPolicy.sections.dataCollected.items.0')}</li>
            <li>{t('privacyPolicy.sections.dataCollected.items.1')}</li>
            <li>{t('privacyPolicy.sections.dataCollected.items.2')}</li>
            <li>{t('privacyPolicy.sections.dataCollected.items.3')}</li>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.purposes.title')}
          </Typography>
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            <li>{t('privacyPolicy.sections.purposes.items.0')}</li>
            <li>{t('privacyPolicy.sections.purposes.items.1')}</li>
            <li>{t('privacyPolicy.sections.purposes.items.2')}</li>
            <li>{t('privacyPolicy.sections.purposes.items.3')}</li>
            <li>{t('privacyPolicy.sections.purposes.items.4')}</li>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.meta.title')}
          </Typography>
          <Typography variant="body1">
            {t('privacyPolicy.sections.meta.body')}
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.cookies.title')}
          </Typography>
          <Typography variant="body1">
            {t('privacyPolicy.sections.cookies.body')}
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.storage.title')}
          </Typography>
          <Typography variant="body1">
            {t('privacyPolicy.sections.storage.body')}
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.rights.title')}
          </Typography>
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            <li>{t('privacyPolicy.sections.rights.items.0')}</li>
            <li>{t('privacyPolicy.sections.rights.items.1')}</li>
            <li>{t('privacyPolicy.sections.rights.items.2')}</li>
            <li>{t('privacyPolicy.sections.rights.items.3')}</li>
            <li>{t('privacyPolicy.sections.rights.items.4')}</li>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('privacyPolicy.sections.contact.title')}
          </Typography>
          <Typography variant="body1">
            {t('privacyPolicy.sections.contact.body')}{' '}
            <MuiLink href="mailto:support@flocktrade.com">support@flocktrade.com</MuiLink>.
          </Typography>
        </Box>
      </Box>
    </Container>
    </>
  );
};

export default PrivacyPolicy;
